import { ChatModuleType } from 'app/copied/models/ChatModules';

import useModule from './useModule';

export enum UnityMode {
  SEARCH_ONLY = 'search_only',
  CONVOAI_WITH_SEARCH = 'convoai_with_search',
  CONVOAI_WITH_CHAT_AND_SEARCH = 'convoai_with_chat_and_search',
}

export default function useUnityMode() {
  const vaModule = useModule(ChatModuleType.VirtualAssistant);

  if (!vaModule) {
    return UnityMode.SEARCH_ONLY;
  }

  if (vaModule.va_allow_use_crafted_responses) {
    return UnityMode.CONVOAI_WITH_CHAT_AND_SEARCH;
  }

  return UnityMode.CONVOAI_WITH_SEARCH;
}
